export default "__VITE_ASSET__D5yT1AIe__"